import image1 from '../../images/col-image-2_370x489_crop_top.progressive.jpg'
import image2 from '../../images/packable_roll_sleeve_anorak_1_370x489_crop_top.progressive.png.jpg'
import image3 from '../../images/vintage_cotton_raglan_pullover_1_370x450_crop_center.progressive.png.jpg'
import image4 from '../../images/rockabilly_print_thermal_top_2_370x450_crop_center.progressive.png.jpg'
import image5 from '../../images/col-image-6_370x450_crop_center.progressive.jpg'
import image6 from '../../images/col-image-5_370x450_crop_center.progressive.jpg'

export const category=[
    {
        id:'001',
        categoryTitle:'Mens',
        subCategory:true,
        collection:true,
        image:image1
    },
    {
        id:'002',
        categoryTitle:'Womens',
        subCategory:true,
        collection:true,
        image:image2
    },
    {
        id:'003',
        categoryTitle:'Accessories',
        subCategory:false,
        collection:true,
        image:image3
    },
    {
        id:'004',
        categoryTitle:'Clothing',
        subCategory:false,
        collection:true,
        image:image4
    },
    {
        id:'005',
        categoryTitle:'Coats & Jackets',
        subCategory:false,
        collection:true,
        image:image5
    },
    {
        id:'006',
        categoryTitle:'Shoes',
        subCategory:false,
        collection:true,
        image:image6
    },
]